import { useEffect, useState } from "react";
import axios from "axios";
import { Sparkles, Users, FileText, TrendingUp, CircleDollarSign, Inbox } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fmt = (n) => `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2 })}`;

export const AdminOverview = ({ onGoLeads }) => {
  const [stats, setStats] = useState(null);
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    (async () => {
      const [s, l] = await Promise.all([
        axios.get(`${API}/admin/stats`, { withCredentials: true }),
        axios.get(`${API}/leads`, { withCredentials: true }),
      ]);
      setStats(s.data);
      setRecent(l.data.slice(0, 5));
    })();
  }, []);

  if (!stats) return <p className="text-sm text-[#A6A6B0]">Loading overview…</p>;

  const cards = [
    { icon: Sparkles, label: "New Leads", value: stats.new_leads, accent: true },
    { icon: Inbox, label: "Total Leads", value: stats.total_leads },
    { icon: Users, label: "Clients", value: stats.total_clients },
    { icon: FileText, label: "Outstanding", value: fmt(stats.outstanding) },
    { icon: CircleDollarSign, label: "Collected", value: fmt(stats.collected) },
  ];

  return (
    <div>
      <h1 className="font-display text-2xl sm:text-3xl font-extrabold uppercase tracking-tight mb-8">
        Overview
      </h1>
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 mb-12">
        {cards.map((c, i) => (
          <div
            key={c.label}
            data-testid={`stat-card-${i}`}
            className={`glass-card rounded-lg p-5 ${
              c.accent ? "border-[#6D00FF]/50 shadow-[0_0_30px_-10px_rgba(109,0,255,0.5)]" : ""
            }`}
          >
            <c.icon className="w-4 h-4 text-[#8B2CFF] mb-3" strokeWidth={1.5} />
            <p className="font-display text-xl sm:text-2xl font-extrabold tracking-tight">
              {c.value}
            </p>
            <p className="text-[11px] uppercase tracking-[0.16em] text-[#A6A6B0]/70 mt-1">
              {c.label}
            </p>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-between mb-5">
        <h2 className="font-display text-lg font-bold uppercase tracking-tight">Recent Enquiries</h2>
        <button
          data-testid="overview-view-leads"
          onClick={onGoLeads}
          className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-[#8B2CFF] hover:text-[#C43CFF] transition-colors duration-300"
        >
          <TrendingUp className="w-3.5 h-3.5" /> View all
        </button>
      </div>
      {recent.length === 0 ? (
        <p className="text-sm text-[#A6A6B0]">No enquiries yet.</p>
      ) : (
        <div className="space-y-3">
          {recent.map((l, i) => (
            <div
              key={l.id}
              data-testid={`recent-lead-${i}`}
              className="glass-card rounded-lg px-5 py-4 flex flex-wrap items-center justify-between gap-3"
            >
              <div>
                <p className="text-sm font-semibold">{l.name}</p>
                <p className="text-xs text-[#A6A6B0] mt-0.5">{l.service || "General enquiry"}</p>
              </div>
              <span
                className={`text-[10px] font-bold uppercase tracking-[0.14em] rounded px-2.5 py-1 ${
                  l.status === "new"
                    ? "bg-[#6D00FF]/20 text-[#E8B6FF]"
                    : "text-[#A6A6B0] border border-white/10"
                }`}
              >
                {l.status}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
